<ip-header [label]="'catalog.image_preview.image_crop_download_options' | transloco"></ip-header>

<div class="p-2 border-bottom">
  {{ 'catalog.image_preview.image_crop_message' | transloco }}
</div>

<ip-crop-form
  [formats]="formats"
  [id]="id"
  [watermarkPositions]="watermarkPositions"
  [watermarkSources]="watermarkSources"
></ip-crop-form>

<ip-license [license]="resolutionData?.license"></ip-license>
